import { ReactComponent as PersonalityIcons } from 'assets/icons/icon-megaphone.svg';
import styled from 'styled-components';

export const PersonalityIcon = styled(PersonalityIcons)`
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.colors.componentsIconDefault};
`;
